import { FormControlLabel, Radio } from '@mui/material';
import { StyledRadioRow, StyledRadioText } from './BulkRadioOption.styles';

const RadioOption = ({ value, label }: { value: string; label: string }) => (
  <StyledRadioRow>
    <FormControlLabel value={value} control={<Radio />} label={<StyledRadioText>{label}</StyledRadioText>} />
  </StyledRadioRow>
);

export default RadioOption;
